import { dataQuery } from './leaderboard-api';
import { autocompleteApiService } from '@autocomplete/service';

export const autocompleteApi = autocompleteApiService(dataQuery);
export const { useGetUserSuggestionsQuery } = autocompleteApi;
